@import './pk-dialog.variables';

:host(.pk-dialog) {
  @include transition(#{'opacity, visibility, z-index'});
  @apply fixed left-0 top-0 -z-10 box-border flex h-screen w-full items-center justify-center p-m opacity-0 sm:p-l;

  visibility: hidden !important;
  height: -webkit-fill-available;
}

:host(.is-open) {
  @apply z-[--dialog--z-index] opacity-100;
  visibility: visible !important;
}

.pk-dialog__base {
  @apply z-[510] flex w-[--dialog--width] flex-col rounded-[--dialog--border-radius] bg-[color:--dialog--background] shadow-02 outline-none;

  &.size {
    &--small {
      @apply h-[--dialog--height-small] w-[--dialog--width-small];
    }

    &--medium {
      @apply h-[--dialog--height-medium] w-[--dialog--width-medium];
    }

    &--large {
      @apply h-[--dialog--height-large] w-[--dialog--width-large];
    }

    &--full {
      @apply h-full w-full;
    }
  }

  &.custom-height {
    @apply h-[--dialog--height];
  }

  &.custom-width {
    @apply w-[--dialog--width];
  }
}

::slotted(pk-simple-header) {
  @apply overflow-hidden rounded-t-[--dialog--border-radius];
}
